import posthog from 'posthog-js';

if (import.meta.env.VITE_PUBLIC_POSTHOG_KEY && import.meta.env.VITE_PUBLIC_POSTHOG_HOST) {
  posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    capture_pageview: false, // captura automaticamente as mudanças de página
    defaults: '2025-05-24',
    person_profiles: 'always',
    loaded: (ph) => {
      console.log('PostHog carregado', ph);
    },
  });
} else {
  console.warn('PostHog não foi configurado. Verifique as variáveis de ambiente.');
}

export default posthog;